module.exports = __webpack_public_path__ + "grandeshistorias_cases.jpg?4b611b7bf0cf764dc00ed4c8361952b2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cases/grandeshistorias_cases.jpg
// module id = 86
// module chunks = 0